import { DEFAULT_LATEST, DEFAULT_EARLIEST } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types';
import { setToStartOfMonth } from 'helpers/date';
import { LegalAssociationsEventItemModel } from '../../eventItem/types';

const legalAssociationsTerrorismAdvocacyItemValidator: ValidateJSModel<LegalAssociationsEventItemModel> = {
  Why: { presence: true, hasValue: true },
  When: (value, attributes, attributeName, options) => ({
    presence: true,
    daterange: { earliest: setToStartOfMonth(options?.applicantBirthdate || DEFAULT_EARLIEST), latest: DEFAULT_LATEST },
  }),
  What: { presence: true, hasValue: true },
};

export default legalAssociationsTerrorismAdvocacyItemValidator;
